import React, { useState } from "react";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://script.google.com/macros/s/AKfycby1lWgFyyEBiezkyg0NielAIC6B-8k1jiSAAA0dAyEU_7apOT4knBLCuPabxOXIZUcj/exec", {
        method: "POST",
        redirect: "follow",
        headers: { "Content-Type": "text/plain;charset=utf-8", },
        body: JSON.stringify(formData),
      });
      if (response.status === 200) {
        alert("Message sent successfully!");
        setFormData({ name: "", email: "", phone: "", message: "" });
      } else {
        alert("Failed to send the message.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error sending message.");
    }
  };

  return (
    <div className="container mx-auto py-6 md:py-12 px-4">
      <div className="flex flex-col lg:flex-row justify-between gap-8">
        <div className="w-full lg:w-1/2 space-y-4">
          <h2 className="text-xl md:text-2xl font-bold text-[#011B5D] mb-4">Get in Touch</h2>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="name" className="block text-base md:text-lg font-medium">Name</label>
              <input
                type="text"
                id="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-md"
                placeholder="Your name"
                required
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-base md:text-lg font-medium">Email</label>
              <input
                type="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-md"
                placeholder="Your email"
                required
              />
            </div>
            <div>
              <label htmlFor="phone" className="block text-base md:text-lg font-medium">Contact Phone</label>
              <input
                type="tel"
                id="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-md"
                placeholder="Your contact number"
              />
            </div>
            <div>
              <label htmlFor="message" className="block text-base md:text-lg font-medium">Message</label>
              <textarea
                id="message"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-md"
                placeholder="Your message"
                required
              ></textarea>
            </div>
            <button
              type="submit"
              className="bg-[#0300AF] text-white py-2 px-6 rounded-md shadow hover:bg-blue-600 w-full md:w-auto"
            >
              Send
            </button>
          </form>
        </div>

        <div className="w-full lg:w-1/2">
          <h2 className="text-xl md:text-2xl font-bold text-[#011B5D] mb-4">Contact Information</h2>
          <div className="space-y-3 md:space-y-4 text-base md:text-lg">
            <p>
              <strong>Mobile:</strong> +91 98453 85842
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:globaleximblr@gmail.com" className="underline text-blue-500">
                globaleximblr@gmail.com
              </a>
            </p>
            <p>
              <strong>Address:</strong> Manidweeps, No K8, 8th Main,<br />
              Ananda Layout, Rajiv Gandhi Nagar,<br />
              Virupakshapura, Bengaluru, Karnataka 560097
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
